const jQ = jQuery.noConflict();
const closeCookie = jQ('.alert__close');
const checkClose = jQ('.alert__checkbox');
const cookieWrapper = jQ('.alert__main-wrapper');
const closeOverlay = jQ('.alert__overlay-close');
const btnCloseOverlay = jQ('.alert__overlay-inner-close');


function setCookie(name, value, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toGMTString()}`;

    document.cookie = `${name}=${value};${expires};path=/`;
}

function getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
const cookies = getCookie('showAlert');

function hideWrapper() {
    cookieWrapper.slideUp();
}

function resetHeader() {
    jQ('.main-header').addClass('fixed-position');
}

function checkCookie() {
    const cookie = getCookie('showAlert');

    if (cookie == '') {
        setCookie('showAlert', true, 1);
        hideWrapper();
        resetHeader();
    }
}

function initCookie() {
    closeCookie.on('click', () => {
        checkCookie();
        hideWrapper();
        resetHeader();
    });

    closeOverlay.on('click', () => {
        if ((checkClose.length > 0) && (checkClose.is(':checked'))) {
            checkCookie();
        }
    });

    btnCloseOverlay.on('click', () => {
        if ((checkClose.length > 0) && (checkClose.is(':checked'))) {
            checkCookie();
        }
    });

    if (cookies === '') {
        cookieWrapper.addClass('alert-visible');
    }
}

export { initCookie, getCookie };
